import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MoonshotCreateFirstBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoonshotCreateFirstBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortLink"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MoonshotCreateFirstBoard","document":MoonshotCreateFirstBoardDocument}} as const;
export type MoonshotCreateFirstBoardQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type MoonshotCreateFirstBoardQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { boards: Array<(
      { __typename: 'Board' }
      & Pick<Types.Board, 'id' | 'shortLink'>
      & { organization?: Types.Maybe<(
        { __typename: 'Organization' }
        & Pick<Types.Organization, 'id' | 'name'>
      )> }
    )> }
  )> }
);

/**
 * __useMoonshotCreateFirstBoardQuery__
 *
 * To run a query within a React component, call `useMoonshotCreateFirstBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoonshotCreateFirstBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoonshotCreateFirstBoardQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMoonshotCreateFirstBoardQuery(
  baseOptions: TrelloQueryHookOptions<
    MoonshotCreateFirstBoardQuery,
    MoonshotCreateFirstBoardQueryVariables
  > &
    (
      | { variables: MoonshotCreateFirstBoardQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MoonshotCreateFirstBoardDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MoonshotCreateFirstBoardQuery,
    MoonshotCreateFirstBoardQueryVariables
  >(MoonshotCreateFirstBoardDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMoonshotCreateFirstBoardLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MoonshotCreateFirstBoardQuery,
    MoonshotCreateFirstBoardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MoonshotCreateFirstBoardQuery,
    MoonshotCreateFirstBoardQueryVariables
  >(MoonshotCreateFirstBoardDocument, options);
}
export function useMoonshotCreateFirstBoardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        MoonshotCreateFirstBoardQuery,
        MoonshotCreateFirstBoardQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MoonshotCreateFirstBoardQuery,
    MoonshotCreateFirstBoardQueryVariables
  >(MoonshotCreateFirstBoardDocument, options);
}
export type MoonshotCreateFirstBoardQueryHookResult = ReturnType<
  typeof useMoonshotCreateFirstBoardQuery
>;
export type MoonshotCreateFirstBoardLazyQueryHookResult = ReturnType<
  typeof useMoonshotCreateFirstBoardLazyQuery
>;
export type MoonshotCreateFirstBoardSuspenseQueryHookResult = ReturnType<
  typeof useMoonshotCreateFirstBoardSuspenseQuery
>;
export type MoonshotCreateFirstBoardQueryResult = Apollo.QueryResult<
  MoonshotCreateFirstBoardQuery,
  MoonshotCreateFirstBoardQueryVariables
>;
